import { IEnvironment } from './environment.type';
import { baseEnv } from './environment.base';

export const environment: IEnvironment = {
    ...baseEnv,
    backendUrl: 'https://app-iqenergy-euw-dev-fe-apps1.azurewebsites.net',
}
